import type { z } from 'zod'

import { resolveClientIssueMessage } from '~/composables/resolveClientIssueMessage'
import type { TranslateFn } from '~/composables/TranslateFn'
import { PhoneNumber } from '~/utils/PhoneNumber'
import { phoneIssueVerdict } from '~/composables/phoneIssueVerdict'
import { resolvePhoneMessageOr } from '~/composables/resolvePhoneMessageOr'

/** Display text of a client zod issue: a phone rule resolves from its verdict, any other issue from its message. */
export function resolveIssueDisplay(issue: z.core.$ZodIssue, t: TranslateFn): string {
  const issueVerdict = phoneIssueVerdict(
    issue.code === 'custom' ? PhoneNumber.ruleVerdict(issue.params) : undefined
  )
  return resolvePhoneMessageOr(t, issueVerdict, () => resolveClientIssueMessage(issue.message, t))
}
